// Crop the outer map to inner map which is not hidden by the panels (cropped map is the map that is visible to the user)
const getCroppedMapDimensions = (outerMapDimensions: { width: number, height: number }, panelDimensions: { horizontal: number; vertical: number; }) => {
  const { width: outerMapWidth, height: outerMapHeight } = outerMapDimensions;
  const { horizontal: horizontalPanelsWidth, vertical: verticalPanelsHeight } = panelDimensions;

  const isInnerMapTooShort = verticalPanelsHeight >= outerMapHeight;
  const isInnerMapTooNarrow = horizontalPanelsWidth >= outerMapWidth;

  // If inner (cropped) map is too small, just use the outer map dimensions
  return {
    width: isInnerMapTooNarrow ? outerMapWidth : outerMapWidth - horizontalPanelsWidth,
    height: isInnerMapTooShort ? outerMapHeight : outerMapHeight - verticalPanelsHeight,
  };
};

export default getCroppedMapDimensions;
